import React from 'react';
import hoistNonReactStatic from 'hoist-non-react-statics';

import { OffsetContext } from './OffsetProvider';

const withOffset = (WrappedComponent) => {
  const OffsetWrapperComponent = (props) => {
    return (
      <OffsetContext.Consumer>
        {({ topOffSet, bottomOffset }) => (
          <WrappedComponent {...props} topOffset={topOffSet} bottomOffset={bottomOffset} />
        )}
      </OffsetContext.Consumer>
    );
  };
  return hoistNonReactStatic(OffsetWrapperComponent, WrappedComponent);
};

export default withOffset;
